import settings from '@/settings'

let precosPorPosto = (cnpjPosto, headers) => {
  return fetch(`${settings.apetrusApi}/precoscombustivel/porposto/?cnpj=${cnpjPosto}`, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

let precosPorCombustivel = (id, cnpjPosto, headers) => {
  return fetch(`${settings.apetrusApi}/precoscombustivel/porposto/?cnpj=${cnpjPosto}&id_combustivel=${id}`, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

let cancelarPreco = (id, cnpjPosto, headers) => {
  return fetch(`${settings.apetrusApi}/precoscombustivel/cancelar/?cnpj=${cnpjPosto}&id=${id}`, {
    method: 'DELETE',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

let silenciar = (id, cnpjPosto, headers) => {
  return fetch(`${settings.apetrusApi}/precoscombustivel/silenciar/?cnpj=${cnpjPosto}&id=${id}`, {
    method: 'PUT',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

let escutar = (id, cnpjPosto, headers) => {
  return fetch(`${settings.apetrusApi}/precoscombustivel/escutar/?cnpj=${cnpjPosto}&id=${id}`, {
    method: 'PUT',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

let inserir = (combustivel, headers) => {
  return fetch(`${settings.apetrusApi}/combustiveis/cadastrar/`, {
    method: 'POST',
    body: JSON.stringify(combustivel),
    mode: 'cors',
    headers: headers
  })
}

let cadastrarPreco = (combustivel, headers) => {
  return fetch(`${settings.apetrusApi}/precoscombustivel/cadastrar/`, {
    method: 'POST',
    body: JSON.stringify(combustivel),
    mode: 'cors',
    headers: headers
  })
}

let getCombustiveis = (headers) => {
  return fetch(`${settings.apetrusApi}/combustiveis/unpaginated/`, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

let getCombustiveisSilenciados = (cnpjPosto, headers) => {
  return fetch(`${settings.apetrusApi}/combustiveis/silenciados/?cnpj=${cnpjPosto}`, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

export default {
  precosPorCombustivel,
  cancelarPreco,
  inserir,
  precosPorPosto,
  cadastrarPreco,
  getCombustiveis,
  getCombustiveisSilenciados,
  silenciar,
  escutar
}
